import { SelectOptionType } from '@octano/global-ui';
import { AxiosError } from 'axios';

import request, { AxiosResult } from '../../../api/request';

const HOMOLOGATION_CONFIG = {
  GET_APPROVERS: () =>
    '/maintainers-portal/general-configuration/homologation-configuration/approvers',
  SAVE_APPROVERS: () =>
    '/maintainers-portal/general-configuration/homologation-configuration/approvers',
  SEARCH_USERS: () =>
    '/maintainers-portal/general-configuration/homologation-configuration/approvers/search-users',
  IS_APPROVER: () =>
    '/maintainers-portal/general-configuration/homologation-configuration/approvers/is-approver',
};

export interface ApproverSettings {
  approverEmails: string[];
}

export interface UserSearchResult {
  accountId: number;
  name: string;
  email: string;
  identification: string;
  rolName?: string;
}

export interface HomologationFormData {
  userOptions: SelectOptionType[];
  savedApprovers: SelectOptionType[];
}

export function getApprovers() {
  return request<ApproverSettings>(HOMOLOGATION_CONFIG.GET_APPROVERS());
}

export function saveApprovers(approverEmails: string[]) {
  return request<any>(HOMOLOGATION_CONFIG.SAVE_APPROVERS(), {
    method: 'POST',
    data: { approverEmails },
  });
}

export function searchUsers(searchText?: string, limit?: number) {
  return request<UserSearchResult[]>(HOMOLOGATION_CONFIG.SEARCH_USERS(), {
    params: { search_text: searchText, limit },
  });
}

export function checkIsApprover() {
  return request<{ isApprover: boolean }>(HOMOLOGATION_CONFIG.IS_APPROVER());
}

export async function getHomologationFormData(): Promise<
  AxiosResult<HomologationFormData>
> {
  try {
    const [usersResponse, approversResponse] = await Promise.all([
      searchUsers(undefined, 500),
      getApprovers(),
    ]);

    const users = usersResponse.data ?? [];
    const userOptions: SelectOptionType[] = users.map((user) => ({
      label: `${user.name}${user.rolName ? ` - ${user.rolName}` : ''} (${
        user.email
      })`,
      value: user.email,
    }));

    const savedEmails = approversResponse.data?.approverEmails ?? [];
    const savedApprovers = userOptions.filter((opt) =>
      savedEmails.includes(String(opt.value)),
    );

    return { data: { userOptions, savedApprovers } };
  } catch (err) {
    return {
      error: {
        code: 'CONNECTION' as const,
        error: err as AxiosError,
      },
    };
  }
}
